module.exports = __webpack_public_path__ + "img/wsfIcon.0a599e2d.png";